import { CategoricalColumn, StringColumn } from 'baseui/data-table';
import dayjs from 'dayjs';
import _get from 'lodash/get';
import { EMPTY_STRING } from 'commons-ui';

export const COL_NAMES = {
	userName: 'userName',
	role: 'role',
	email: 'email',
	createdAt: 'created_at',
	createdBy: 'created_by',
	modifiedAt: 'modified_at',
	modifiedBy: 'modified_by'
};

export const columnConfigs = [
	StringColumn({
		title: 'Username',
		mapDataToValue: (data: any) => {
			const val = _get(data, COL_NAMES.userName);
			return val ?? EMPTY_STRING;
		}
	}),
	CategoricalColumn({
		title: 'Role',
		mapDataToValue: (data: any) => {
			const val = _get(data, COL_NAMES.role);
			return val ?? EMPTY_STRING;
		}
	}),
	StringColumn({
		title: 'Email ID',
		mapDataToValue: (data: any) => {
			const val = _get(data, COL_NAMES.email);
			return val ?? EMPTY_STRING;
		}
	}),
	StringColumn({
		title: 'Created By',
		mapDataToValue: (data: any) => {
			const val = _get(data, COL_NAMES.createdBy);
			return val ?? 'NA';
		}
	}),
	StringColumn({
		title: 'Created At',
		mapDataToValue: (data: any) => {
			return _get(data, COL_NAMES.createdAt)
				? dayjs(new Date(_get(data, COL_NAMES.createdAt))).format('DD-MM-YYYY hh:mm A')
				: 'NA';
		}
	}),
	StringColumn({
		title: 'Modified By',
		mapDataToValue: (data: any) => {
			const val = _get(data, COL_NAMES.modifiedBy);
			return val ?? 'NA';
		}
	}),
	StringColumn({
		title: 'Modified At',
		mapDataToValue: (data: any) => {
			return _get(data, COL_NAMES.modifiedAt)
				? dayjs(new Date(_get(data, COL_NAMES.modifiedAt))).format('DD-MM-YYYY hh:mm A')
				: 'NA';
		}
	})
];

export default { columnConfigs, COL_NAMES };
